import { createAction } from "redux-act";

// Detail
export const MEMRegisDeviceDetail = createAction("MEM_REGISDEVICEDETAIL");